import { render, staticRenderFns } from "./ListChat.vue?vue&type=template&id=00d6f960&scoped=true"
import script from "./ListChat.vue?vue&type=script&lang=js"
export * from "./ListChat.vue?vue&type=script&lang=js"
import style0 from "./ListChat.vue?vue&type=style&index=0&id=00d6f960&prod&lang=css&scoped=true"
import style1 from "./ListChat.vue?vue&type=style&index=1&id=00d6f960&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d6f960",
  null
  
)

export default component.exports